<template>
    <div>
        <h5 class="heading-1 mb-4">
            <span>OCORRÊNCIAS</span>
        </h5>
        <app-tabela
            :itens="contrato.ocorrenciasGerais"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
        </app-tabela>
    </div>
</template>

<script>
export default {
    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            erros: [],
            campos: [
                {
                    key: 'dtOcorrencia',
                    label: 'Data da Ocorrência',
                    sortable: true,
                    type: 'datetime'
                },
                {
                    key: 'usrLogin',
                    label: 'Usuário',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'ocorrencia',
                    label: 'Ocorrência',
                    filterable: true
                }
            ],
            itensPorPagina: 10
        }
    }
}
</script>